// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `tr.table-hover td {
	background-color: var(--bs-table-hover-bg);
}
`, "",{"version":3,"sources":["webpack://./src/styles/galleryTable.css"],"names":[],"mappings":"AAAA;CACC,0CAA0C;AAC3C","sourcesContent":["tr.table-hover td {\n\tbackground-color: var(--bs-table-hover-bg);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
